/**
 * @file: showAlert.web.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */
export async function showAlert(
  title: string,
  message?: string,
): Promise<void> {
  alert(message ?? title);
}
